import { FieldError } from "react-hook-form";
import cx from "classnames";
import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import InputLabel from "../InputLabel";
import InputError from "../InputError";

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: ReactNode;
  error?: FieldError;
  mask?: string;
  className?: string;
  inputClassName?: string;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { required, placeholder, error, label, className, inputClassName, ...rest },
    ref
  ) => {
    return (
      <div className={cx(`relative flex w-full flex-col`, className ?? "")}>
        <InputLabel required={required} value={label} />
        <input
          ref={ref}
          className={cx(
            `h-10 rounded border border-gray-400 bg-white px-[11px] py-2 text-body font-normal text-gray-700 placeholder:text-gray-500 hover:border-gray-500 focus:border-green-3 focus:outline-none focus:ring-0 active:border-gray-600 disabled:bg-disabled disabled:text-disabled`,
            error ? "border-red-600" : "",
            inputClassName ?? ""
          )}
          type="text"
          placeholder={placeholder}
          {...rest}
        />
        <InputError value={error?.message} />
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
